/**
 * Plan aggregate (domain layer).
 */

export type PlanType = 'starter' | 'professional' | 'enterprise' | 'custom';

export interface Plan {
  id: string;
  name: string;
  plan_type: PlanType;
  base_rate: string;
  monthly_fee: string;
  included_messages: number;
  max_messages_per_day: number | null;
  max_messages_per_month: number | null;
  features: Record<string, unknown>;
  is_active: boolean;
  created_at: string;
  customer_count?: number;
}

export interface PlanCreateInput {
  name: string;
  plan_type: PlanType;
  base_rate: string;
  monthly_fee: string;
  included_messages: number;
}

export type PlanUpdateInput = Partial<PlanCreateInput>;

export const PLAN_TYPES: PlanType[] = ['starter', 'professional', 'enterprise', 'custom'];

export const isValidPlanInput = (
  input: Partial<PlanCreateInput>,
): input is PlanCreateInput => {
  if (!input.name || !input.name.trim()) return false;
  if (!input.plan_type || !PLAN_TYPES.includes(input.plan_type)) return false;
  if (!input.base_rate || !(Number(input.base_rate) > 0)) return false;
  if (input.monthly_fee === undefined || Number(input.monthly_fee) < 0) return false;
  if (input.included_messages === undefined || input.included_messages < 0) return false;
  return true;
};
